import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32410 23823"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:469.707}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M4812 16294H1215V9162h3597v7132zm980 492V8670c0-270-219-492-490-492H725c-271 0-490 222-490 492v8116c0 270 219 493 490 493h4578c270 0 489-223 489-493zM15762 21896l-7926-5373V8892l7926-7072v20076zm163-21537L7019 8306c-104 94-165 222-165 364l1 8116c0 162 80 317 215 405l8907 6040c83 54 179 81 274 81 80 0 158-20 231-54 160-88 260-256 260-438l1-22095c0-193-114-368-291-447-176-79-382-48-527 81zM26390 21768c2466-2400 3824-5609 3824-9039 0-3432-1358-6641-3824-9037-193-190-198-500-9-694 95-99 224-148 351-148 123 0 247 46 342 138 2657 2581 4121 6039 4121 9741 0 3700-1464 7158-4121 9740-194 189-505 182-693-7-90-94-139-215-139-344 0-134 53-262 148-350zm-1129 351c0 384 148 748 416 1024 289 297 671 445 1055 445 370 0 740-141 1025-418 2849-2764 4418-6478 4418-10441 0-3965-1569-7679-4418-10445-581-565-1514-553-2080 31-565 581-552 1515 30 2080 2274 2212 3526 5172 3526 8334 0 3168-1253 6120-3526 8331-287 283-446 654-446 1059zM20606 18323c1546-1476 2397-3458 2397-5594 0-2131-851-4120-2397-5596-94-94-148-216-151-343-4-136 45-257 135-351 91-95 212-149 344-155h11c127 0 246 47 339 135 1741 1665 2700 3903 2700 6310 0 2406-959 4644-2701 6309-94 88-220 142-349 135-131-7-253-61-344-156-87-87-135-208-135-336 0-135 53-263 151-358zm-1132 358c0 384 144 741 407 1018 271 283 637 444 1030 451h35c381 0 739-141 1015-404 1937-1854 3003-4342 3003-7017 1-2677-1066-5164-3003-7018-284-270-664-411-1050-405-393 7-759 169-1030 452-272 283-416 661-407 1052s170 755 454 1031c1351 1287 2094 3027 2094 4888 0 1860-743 3599-2094 4886-288 277-454 668-454 1066z"
        className="fill storke1"
        style={{
          strokeWidth: 469.707,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
